import './Landing.css';
import maizeImg from '../../assets/images/programs/training/maize.png';
import { useNavigate } from 'react-router-dom';

export default function Landing() {
    const navigate = useNavigate();
    return(
        <section className="landing-section">
                <div className="landing">
                    <span className="left">
                        <div className="caption1">
                            <h4>THE FOUNDATION</h4>
                        </div>
                        <div className="titles">
                            <div className="caption2">
                                <p>Cultivating <span>Resilience,</span> Empowering <span>Youth,</span> and Protecting our <span>Planet.</span></p>
                            </div>
                            <div className="caption3">
                                <p>Dedicated to driving systemic change, Showbouys Foundation LBG leads the way in sustainable agriculture, environmental stewardship, and holistic community development. We empower individuals and communities to build a resilient future, ensuring a lasting impact for generations to come.</p>
                            </div>
                            <div className="btns">
                                <button onClick={() => navigate("/about")} type="button" className="btn btn-custom">Read More</button>
                                <button type="button" className="btn btn-custom" onClick={()=>navigate("/donate")}>Donate Now</button>
                            </div>
                        </div>

                    </span>
                    <span className="right">
                        <div className="image-container">
                            <img src={maizeImg} alt="Showbouys Foundation" className="landing-img" />
                        </div>
                    </span>
                </div>
        </section>
    );
}